export function resolveActivityPlanTitle(
  customTitle: string,
  fallbackTitle: string,
  requiresCustomTitle: boolean
): string {
  const trimmedTitle = customTitle.trim();
  if (requiresCustomTitle) return trimmedTitle;
  return trimmedTitle || fallbackTitle;
}

export function isActivityTitleReady(
  customTitle: string,
  requiresCustomTitle: boolean
): boolean {
  return !requiresCustomTitle || customTitle.trim().length > 0;
}
